import React, { Component } from "react";
import Header from "../../components/header/Header";
import Greeting from "../../containers/greeting/Greeting";
import About from "../../containers/about/About";
import Slideshow from "../../components/slideshow/Slideshow";
import ProjectsSection from "../../containers/projectsSection/ProjectsSection";
import CalendarSection from "../../containers/calendar/CalendarSection";
import ServicesSection from "../../containers/services/ServicesSection";
import LeadershipSection from "../../containers/leadership/LeadershipSection";
import MapSection from "../../containers/map/MapSection";
import DonationsSection from "../../containers/donations/DonationsSection";
import ContactSection from "../../containers/contactSection/ContactSection";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import "./Landing.css";

class Landing extends Component {
  render() {
    return (
      <div className="landing-main">
        <Header theme={this.props.theme} />

        {/* Hero/Greeting Section */}
        <section id="hero" className="landing-section">
          <Greeting theme={this.props.theme} />
        </section>

        {/* About Section */}
        <section id="about" className="landing-section">
          <About theme={this.props.theme} />
        </section>

        {/* Slideshow Gallery */}
        <section id="gallery" className="landing-section">
          <Slideshow theme={this.props.theme} />
        </section>

        {/* Fundraising / Building Project */}
        <section id="projects" className="landing-section">
          <ProjectsSection theme={this.props.theme} />
        </section>

        {/* Calendar */}
        <section id="calendar" className="landing-section">
          <CalendarSection theme={this.props.theme} />
        </section>

        {/* Services / Worship Schedule */}
        <section id="services" className="landing-section">
          <ServicesSection theme={this.props.theme} />
        </section>

        {/* Leadership & Contact */}
        <section id="leadership" className="landing-section">
          <LeadershipSection theme={this.props.theme} />
        </section>

        {/* Google Map of Address */}
        <section id="location" className="landing-section">
          <MapSection theme={this.props.theme} />
        </section>

        {/* Donations / Bank info / Givealittle */}
        <section id="donations" className="landing-section">
          <DonationsSection theme={this.props.theme} />
        </section>

        {/* Contact Section */}
        <section id="contact" className="landing-section">
          <ContactSection theme={this.props.theme} />
        </section>

        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Landing;
